import {Workbox} from 'workbox-window';

import {Injector} from '@angular/core';
import {environment, setGlobalWorkbox, workbox} from '@shared-types';

import {VersionManagementService} from './services';

/* -------------------------------------------------------------------------------------------------------------- */
/* -------------------------------------------------------------------------------------------------------------- */
export async function regiserServiceWorker(): Promise<ServiceWorkerRegistration> {
	if ('serviceWorker' in navigator && environment.production) {
		const SW_PATH = '/sw.js';
		const wb = new Workbox(SW_PATH);
		setGlobalWorkbox(wb);
		return wb.register();
	}
	return null;
}

/* -------------------------------------------------------------------------------------------------------------- */

export async function connectServiceWorker(injector: Injector): Promise<boolean> {
	const versionService = injector.get(VersionManagementService);
	// Initialize the service with the Workbox instance
	versionService.initialize(workbox);
	// Check for updates at	app startup
	await versionService.checkForUpdates();
	return true; // Proceed with app bootstrap
}
